import axios from 'axios';
import authService from '@/auth';
import activeOfficeService from '@/service/ActiveOfficeService';

const API_URL = '/api/';

class BaseApi {
  constructor(url) {
    this.api = axios.create({
      baseURL: `${API_URL}${url}`,
    });

    this.api.interceptors.request.use(this.applyAuthToken);
    this.api.interceptors.request.use(this.applyActiveOffice);
  }

  combineUrls(baseURL) {
    return (request) => {
      request.url = baseURL + request.url;
      return request;
    };
  }

  async applyAuthToken(config) {
    if (config.baseURL === '/api/user/' && config.url != null && config.url.toString().startsWith('authenticate')) {
      return config;
    }

    if (config.headers.Authorization != null) {
      return config;
    }

    const accessToken = await authService.getAccessToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken.token}`;
    }
    return config;
  }

  applyActiveOffice(config) {
    const activeOffice = activeOfficeService.getActiveOffice();
    if (activeOffice) {
      config.headers.office = activeOffice;
    }
    return config;
  }
}

export { BaseApi };
export default BaseApi;
